export default __webpack_public_path__ + "static/media/create-account.20ce5ca4.png";